import { ResultBadge } from "@/components/ui/result-badge";
import { cn } from "@/lib/utils";

export default function ResultLabel({
  bad,
  children,
  className,
  size,
}: {
  bad?: boolean;
  children: React.ReactNode;
  className?: string;
  size?: "sm" | "md";
}) {
  return (
    <div className="flex select-none items-center gap-2">
      <ResultBadge bad={bad} size={size} />
      <span className={cn("text-gray-1000 text-sm", className)}>
        {children}
      </span>
    </div>
  );
}
